var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[(_vm.FooterData)?_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.FooterData.Footer_Text)}}):_vm._e(),_c('div',{staticClass:"bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }